import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c12dbece"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "floating-save-reminder" }
const _hoisted_3 = { class: "badge badge-light-danger" }
const _hoisted_4 = { class: "card-header border-0" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = { class: "fw-bolder m-0" }
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_18 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-8 fv-row" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_43 = { class: "col-lg-8 fv-row" }
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "row mb-6" }
const _hoisted_47 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_48 = { class: "col-lg-8 fv-row" }
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "row mb-6" }
const _hoisted_52 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-8 fv-row" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "col-lg-8 fv-row" }
const _hoisted_58 = { class: "row mb-6" }
const _hoisted_59 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_60 = { class: "col-lg-8 fv-row" }
const _hoisted_61 = { class: "row mb-6" }
const _hoisted_62 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "col-lg-8 fv-row" }
const _hoisted_64 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_65 = ["value"]
const _hoisted_66 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_69 = { class: "col-lg-8 fv-row" }
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_72 = { class: "col-lg-8 fv-row" }
const _hoisted_73 = { class: "row mb-6" }
const _hoisted_74 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-8 fv-row" }
const _hoisted_76 = ["value", "selected"]
const _hoisted_77 = { class: "fv-plugins-message-container" }
const _hoisted_78 = { class: "fv-help-block" }
const _hoisted_79 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_80 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_81 = { class: "col-lg-8 fv-row" }
const _hoisted_82 = ["value"]
const _hoisted_83 = { class: "row mb-6" }
const _hoisted_84 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_85 = { class: "col-lg-8 fv-row" }
const _hoisted_86 = { class: "row mb-6" }
const _hoisted_87 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_88 = { class: "col-lg-8 fv-row" }
const _hoisted_89 = {
  key: 1,
  class: "card-footer d-flex justify-content-between py-6 px-9"
}
const _hoisted_90 = { class: "indicator-label" }
const _hoisted_91 = { class: "indicator-progress" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_94 = { class: "d-flex gap-3" }
const _hoisted_95 = { class: "indicator-label" }
const _hoisted_96 = { class: "indicator-label" }
const _hoisted_97 = { class: "indicator-label" }
const _hoisted_98 = { class: "indicator-progress" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_100 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_101 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_102 = { class: "indicator-label" }
const _hoisted_103 = { class: "indicator-progress" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_105 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_106 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButtonClone",
  class: "btn btn-primary"
}
const _hoisted_107 = { class: "indicator-label-clone" }
const _hoisted_108 = { class: "indicator-progress" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_110 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_111 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_112 = {
  key: 1,
  class: "badge badge-light-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'registered-trades'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString('duplicates' + ' : ' + _ctx.registeredTrade.duplicates), 1)
        ], 512), [
          [_vShow, _ctx.registeredTrade.duplicates > 0 && _ctx.showFloatingText]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.translate('updateRegisteredTrades')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.registeredTradeSchema
          }, {
            default: _withCtx(({ values }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('transactionDate')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: "day",
                      name: "transactionDate",
                      class: "form-control form-control-lg form-control-solid",
                      autocomplete: "off",
                      modelValue: _ctx.registeredTrade.transactionDate,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registeredTrade.transactionDate) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ErrorMessage, { name: "transactionDate" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      required: true,
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      placeholder: _ctx.translate('selectAreas'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound'),
                      name: "selectedArea"
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.registeredTrade.area), 1),
                    (_ctx.selectedArea == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.translate('AREA_IS_REQUIRED_FIELD')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('propertyType')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedPropertyType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPropertyType) = $event)),
                      required: true,
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      canDeselect: false,
                      options: _ctx.propertyTypes,
                      placeholder: _ctx.translate('selectPropertyType'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound'),
                      name: "selectedPropertyType"
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"]),
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.registeredTrade.propertyType), 1),
                    (_ctx.selectedPropertyType == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.translate('PROPERTY_TYPE_IS_REQUIRED_FIELD')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.translate('block')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "block",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('block'),
                      modelValue: _ctx.registeredTrade.block,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registeredTrade.block) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_ErrorMessage, { name: "block" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('size')), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "size",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('size'),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updatePricePerSqrM())),
                      modelValue: _ctx.registeredTrade.size,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registeredTrade.size) = $event)),
                        ($event: any) => (values.size = Number(values.size))
                      ],
                      style: {"color":"#0066ff !important","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_ErrorMessage, { name: "size" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('percentage')), 1),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "percentage",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('percentage'),
                      modelValue: _ctx.registeredTrade.percentage,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registeredTrade.percentage) = $event)),
                        values.percentage
                      ]
                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_ErrorMessage, { name: "percentage" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate('price')), 1),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "price",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('price'),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updatePricePerSqrM())),
                      modelValue: _ctx.formattedPrice,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formattedPrice) = $event)),
                      style: {"color":"red !important","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_ErrorMessage, { name: "price" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('pricePerM2')), 1),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "pricePerM2",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('pricePerM2'),
                      modelValue: _ctx.registeredTrade.pricePerM2,
                      "onUpdate:modelValue": [
                        _cache[9] || (_cache[9] = ($event: any) => ((_ctx.registeredTrade.pricePerM2) = $event)),
                        ($event: any) => (
                  values.pricePerM2 = Number(values.pricePerM2)
                )
                      ]
                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_ErrorMessage, { name: "pricePerM2" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.translate('description')), 1),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.descriptionId,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.descriptionId) = $event)),
                      options: _ctx.registeredDescs,
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      canDeselect: false,
                      valueProp: "id",
                      placeholder: _ctx.translate('selectDescription'),
                      noResultsText: _ctx.translate('noResultsFound'),
                      onChange: _ctx.updateDesc
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText", "onChange"]),
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.registeredTrade.propertyCategory), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.translate('descriptionAr')), 1),
                  _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.descriptionAr,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.descriptionAr) = $event)),
                      type: "text",
                      name: "descriptionAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid input-disabled",
                      placeholder: _ctx.translate('descriptionAr'),
                      disabled: "true"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.translate('descriptionEn')), 1),
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.descriptionEn,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.descriptionEn) = $event)),
                      type: "text",
                      name: "descriptionEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid input-disabled",
                      placeholder: _ctx.translate('descriptionEn'),
                      disabled: "true"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.translate('notes')), 1),
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.selectedNote,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedNote) = $event)),
                      as: "select",
                      name: "notes",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateNotes($event.target.value)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_64, _toDisplayString(_ctx.translate('selectNotes')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registeredNotes, (registeredNote) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: registeredNote.id,
                            value: registeredNote['id']
                          }, _toDisplayString(registeredNote['titleAr']), 9, _hoisted_65))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.registeredTrade.action), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.translate('notesAr')), 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.notesAr,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.notesAr) = $event)),
                      type: "text",
                      name: "notesAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid input-disabled",
                      placeholder: _ctx.translate('notesAr'),
                      disabled: "true"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.translate('notesEn')), 1),
                  _createElementVNode("div", _hoisted_72, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.notesEn,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.notesEn) = $event)),
                      type: "text",
                      name: "notesEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid input-disabled",
                      placeholder: _ctx.translate('notesEn'),
                      disabled: "true"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.translate('status')), 1),
                  _createElementVNode("div", _hoisted_75, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "status",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.status,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.status) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusMap, (value, key) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: value,
                            value: value,
                            selected: value === 1
                          }, _toDisplayString(key), 9, _hoisted_76))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode(_component_ErrorMessage, { name: "status" })
                      ])
                    ])
                  ])
                ]),
                (_ctx.status !== 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.translate('statusNotes')), 1),
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(_component_Field, {
                          as: "select",
                          name: "statusNotesId",
                          class: "form-select form-select-solid form-select-lg",
                          modelValue: _ctx.statusNotesId,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.statusNotesId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusNoteMap, (value, key) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: value,
                                value: value
                              }, _toDisplayString(key), 9, _hoisted_82))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.translate('registeredTradeClonedId')), 1),
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "registeredTradeClonedId",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('registeredTradeClonedId'),
                      modelValue: _ctx.registeredTrade.registeredTradeClonedId,
                      "onUpdate:modelValue": [
                        _cache[19] || (_cache[19] = ($event: any) => ((_ctx.registeredTrade.registeredTradeClonedId) = $event)),
                        ($event: any) => (
                  values.registeredTradeClonedId = Number(
                    values.registeredTradeClonedId
                  )
                )
                      ],
                      style: {"color":"#0066ff !important","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.translate('numberOfCloned')), 1),
                  _createElementVNode("div", _hoisted_88, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "numberOfCloned",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('numberOfCloned'),
                      modelValue: _ctx.registeredTrade.numberOfCloned,
                      "onUpdate:modelValue": [
                        _cache[20] || (_cache[20] = ($event: any) => ((_ctx.registeredTrade.numberOfCloned) = $event)),
                        ($event: any) => (
                  values.numberOfCloned = Number(values.numberOfCloned)
                )
                      ],
                      style: {"color":"#0066ff !important","font-weight":"bold"}
                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                (_ctx.status === 5 && _ctx.cloneShow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-warning",
                        ref: "submitButtonBlock",
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.createClones && _ctx.createClones(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.translate('createBlocks')), 1),
                        _createElementVNode("span", _hoisted_91, [
                          _createTextVNode(_toDisplayString(_ctx.translate('creatingBlocks')) + " ", 1),
                          _hoisted_92
                        ])
                      ], 512),
                      _hoisted_93,
                      _createElementVNode("div", _hoisted_94, [
                        (_ctx.registeredTradeId && _ctx.status === 5 && _ctx.registeredTradeId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-primary",
                              ref: "showBlocksListButton",
                              onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.showBlocksList(_ctx.registeredTradeId)), ["prevent"]))
                            }, [
                              _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.translate('showBlocksListing')), 1)
                            ], 512))
                          : _createCommentVNode("", true),
                        (_ctx.registeredTradeId && _ctx.status === 5)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-primary",
                              ref: "showOriginalTradeButton",
                              onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.showOriginalTrade(_ctx.registeredTradeId)), ["prevent"]))
                            }, [
                              _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.translate('showOriginalTrade')), 1)
                            ], 512))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.status === 5)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-warning",
                      ref: "submitButtonBlock",
                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.createBlocksCopy && _ctx.createBlocksCopy(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.translate('createBlocksCopy')), 1),
                      _createElementVNode("span", _hoisted_98, [
                        _createTextVNode(_toDisplayString(_ctx.translate('creatingBlocksCopy')) + " ", 1),
                        _hoisted_99
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'registered-trades'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_101, [
                      _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_103, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_104
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.cloneShow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    (_ctx.can('update', 'registered-trades'))
                      ? (_openBlock(), _createElementBlock("button", _hoisted_106, [
                          _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.translate('clone')), 1),
                          _createElementVNode("span", _hoisted_108, [
                            _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                            _hoisted_109
                          ])
                        ], 512))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_110, [
                (_ctx.cloneCount < _ctx.registeredTrade.duplicates)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString('Cloned ' + _ctx.cloneCount + ' times'), 1))
                  : _createCommentVNode("", true),
                (_ctx.cloneCount == _ctx.registeredTrade.duplicates)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString('Cloned ' + _ctx.cloneCount + ' times'), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}